module.exports = __webpack_public_path__ + "static/media/icons_ethic.7f4e3a6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons_ethic.png
// module id = 527
// module chunks = 0